import './Switch.sass';

import React, { FC } from 'react';

import { SwitchProps } from './Switch.interface';
import { classNames } from '$utils';

export const Switch: FC<SwitchProps> = (props) => {
  const { checked, onClick, onChange } = props;

  return (
    <div
      className={classNames({
        Switch: true,
        checked,
      })}
      onClick={() => {
        onClick && onClick();
        onChange && onChange(!checked);
      }}
    >
      <div className="Switch__handle" />
    </div>
  );
};
